var processInclude = require('./components/processInclude');

$(document).ready(function () {
    processInclude(require('./sizefit/sizefit'));
});
